import {
  QUERY_FREE_PURCHASE_TYPE,
  MUTATION_INVITE_TOTE_FREE_PURCHASE
} from 'src/app/queries/queries.js'
const purchaseFreeService = (success, error) => {
  return {
    type: 'API:FETCH:FREE_PURCHASE_TPYE',
    API: true,
    method: 'POST',
    url: '/api/query',
    success,
    error,
    data: {
      query: QUERY_FREE_PURCHASE_TYPE
    }
  }
}

const inviteToteFreePurchase = (input, success, error) => {
  return {
    type: 'API:MUTATION:INVITE_FREE_PURCHASE',
    API: true,
    method: 'POST',
    url: '/api/query',
    data: {
      query: MUTATION_INVITE_TOTE_FREE_PURCHASE,
      variables: {
        input
      }
    },
    success,
    error
  }
}

export default {
  purchaseFreeService,
  inviteToteFreePurchase
}
